import _styled from "@emotion/styled-base";
import { Link } from 'gatsby';
export var Section = _styled("section", {
  target: "e2mht7q0"
})("position:relative;width:100%;padding:400px 0;", function (_ref) {
  var separatorTop = _ref.separatorTop;
  return separatorTop && "padding-top: 200px";
}, ";");
export var OrangeSection =
/*#__PURE__*/
_styled(Section, {
  target: "e2mht7q1"
})({
  name: "1aox60u",
  styles: "background:linear-gradient(#ff6c00,#fbd006);"
});
export var TechStackSection =
/*#__PURE__*/
_styled(Section, {
  target: "e2mht7q2"
})("background:url('", function (_ref2) {
  var imgSrc = _ref2.imgSrc;
  return imgSrc;
}, "') no-repeat center bottom;background-size:cover;");
export var Content = _styled("div", {
  target: "e2mht7q3"
})({
  name: "4v7665",
  styles: "position:relative;z-index:1;max-width:700px;width:100%;margin:0 auto;padding:0 24px;p{font-size:20px;line-height:30px;font-weight:400;margin-bottom:40px;}a{text-decoration:underline;color:black;font-weight:800;cursor:pointer;}h3{margin:0;margin-bottom:8px;}"
});
export var SectionTitle = _styled("h2", {
  target: "e2mht7q4"
})({
  name: "mbf0wd",
  styles: "font-size:32px;font-weight:900;margin:0;margin-bottom:12px;@media (min-width:768px){font-size:40px;}@media (min-width:1024px){font-size:52px;}"
});
export var Separator = _styled("div", {
  target: "e2mht7q5"
})("position:absolute;bottom:-5px;width:100%;height:100%;background:url('", function (_ref3) {
  var imgSrc = _ref3.imgSrc;
  return imgSrc;
}, "') no-repeat;background-position:center bottom;background-size:cover;");
export var TopSeparator =
/*#__PURE__*/
_styled(Separator, {
  target: "e2mht7q6"
})({
  name: "1spc596",
  styles: "background-position:center top;top:0;"
});
export var Page = _styled("div", {
  target: "e2mht7q7"
})({
  name: "1y4w168",
  styles: "padding:200px 40px;display:flex;flex-direction:column;align-items:center;text-align:center;"
});
export var PageTitle = _styled("h1", {
  target: "e2mht7q8"
})({
  name: "23aisr",
  styles: "width:100%;text-align:center;font-weight:900;font-size:32px;line-height:50px;margin:0;color:black;letter-spacing:2px;margin-bottom:8px;@media (min-width:768px){font-size:80px;line-height:90px;}@media (min-width:1024px){font-size:100px;line-height:104px;margin-bottom:32px;}"
});
export var PageSubtitle = _styled("span", {
  target: "e2mht7q9"
})({
  name: "11fiutm",
  styles: "width:100%;font-size:20px;font-weight:900;margin:0;margin-bottom:80px;@media (min-width:768px){font-size:28px;}@media (min-width:1024px){font-size:32px;}"
});
export var BlogListWrapper = _styled("div", {
  target: "e2mht7q10"
})({
  name: "1hcowhz",
  styles: "display:grid;grid-template-columns:1fr;grid-gap:80px;max-width:960px;width:100%;margin:0 auto;@media (min-width:768px){grid-template-columns:1fr 1fr;}"
});
export var BlogArticle =
/*#__PURE__*/
_styled(Link, {
  target: "e2mht7q11"
})({
  name: "1ihaz2z",
  styles: "width:100%;box-shadow:0 50px 80px -20px rgba(50,50,93,0.25),0 30px 60px -30px rgba(0,0,0,0.3),0 -18px 60px -10px rgba(0,0,0,0.025);background-color:white;padding:40px;border:1px solid #f4f4f4;border-radius:15px;text-align:center;text-decoration:none;color:black;transition:transform 0.3s;&:hover{transform:translateY(-2px);}"
});
export var ArticleTitle = _styled("h2", {
  target: "e2mht7q12"
})({
  name: "uqxt9u",
  styles: "margin:0;margin-bottom:12px;"
});
export var ArticleDescription = _styled("p", {
  target: "e2mht7q13"
})({
  name: "1uk1gs8",
  styles: "margin:0;"
});